import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type PayrollExpenseDetailsFormAnalyticIds = {
  amountAnalyticId: string;
  jobTitleAnalyticId: string;
  countryAnalyticId: string;
  stateAnalyticId: string;
};

export const usePayrollExpenseDetailsFormAnalyticIds = (): PayrollExpenseDetailsFormAnalyticIds => ({
  amountAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_AMOUNT),
  jobTitleAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_JOB_TITLE),
  countryAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_COUNTRY),
  stateAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_STATE),
});
